import React from 'react';

import { Role } from '../../types';
import MiniCard from '../MiniCard';


const RoleMiniCard = ({ role }: { role: Role }) => (
  <MiniCard
    icon="user"
    label={role.name}
    description=""
  />
);

export default RoleMiniCard;
